import React, { useState, useEffect, useRef } from 'react';

import DotsPlotComponent from './Component';

const MIN_DOTS_PLOT_HEIGHT = 500;

const DotsPlotContainer = props => {
  const [height, setHeight] = useState(0);
  const [width, setWidth] = useState(0);
  const containerRef = useRef(null);

  useEffect(() => {
    setWidth(Math.max(
      containerRef.current.clientWidth,
      MIN_DOTS_PLOT_HEIGHT
    ));

    setHeight(Math.max(
      containerRef.current.clientHeight,
      MIN_DOTS_PLOT_HEIGHT
    ));
  }, [width]);

  return (
    <div ref={containerRef} className="flex">
      {
        containerRef.current &&
        <DotsPlotComponent
          {...props}
          width={width}
          height={height}
        />
      }
    </div>
  );
};

export default DotsPlotContainer;
